(function($, undefined) {

	'use strict';
	var doc = $(document);
	var currPage;
	var transitionEnd = 'transitionend webkitTransitionEnd oTransitionEnd otransitionend';
	var body;
	var items;
	var checkLabel;
	var checkboxItems;
	var checkboxItemsInner;
	var file;
	var fileInput;
	var formSwitch;
	var formCheck;
	var selectCountry;
	var daysCell;

	var validateForm = function (form) {
		$(form).each(function () {
			var ctn = $(this);
			var toValidateItems = $('.form-input:not(.select-state-input:not(.selected))', ctn);
			var toValidateUpload = $('.form-input-upload.required', ctn);
			var toValidateCheck = $('.form-check-input.required, .form-check-input.min-one-checked', ctn);
			var password = $('.js-password', ctn);
			var passwordConfirm = $('.js-password-confirm', ctn);
			var email = $('.js-email', ctn);
			var emailConfirm = $('.js-email-confirm', ctn);
			var btn = $('.js-form-btn', ctn);
			var isOk = true;
			var passwordOk = true;
			var termsOk = true;
			var checkOk = true;
			var emailOk = true;
			var containsOk = true;
			var fieldsErrorMessage = $('.js-form-error-message.fields', ctn);
			var fieldsErrorCheckbox = $('.js-form-error-message.checkbox', ctn);
			var fieldsErrorTerms = $('.js-form-error-message.terms', ctn);
			var fieldsErrorPassword = $('.js-form-error-message.password', ctn);
			var fieldsErrorEmail = $('.js-form-error-message.email-check', ctn);
			var fieldsErrorContains = $('.js-form-error-message.contains', ctn);

			toValidateItems.each(function () {
				var tChild = $(this);
				validateField(tChild);

				if (tChild.hasClass('error')) {
					isOk = false;
				}
			
				if (tChild.hasClass('validate-contain') && tChild.val() !== '') {
                    var splitChar = tChild.attr('data-split');
					var containsList = splitChar && splitChar !== '' ? tChild.attr('data-contain').split(splitChar) : [tChild.attr('data-contain')];

                    if (containsList.indexOf(tChild.val()) > -1) {
                        tChild.addClass('error').removeClass('success');
                        containsOk = false;
                    }
				}
			});

			toValidateUpload.each(function () {
				var tUpload = $(this);
				var input = $('.form-input-upload-input', tUpload);

				if (input.val() === '') {
					tUpload.addClass('error');
				}

				if (tUpload.hasClass('error')) {
					isOk = false;
				}
			});

			toValidateCheck.each(function () {
				var tCheck = $(this);
				var tCtn = tCheck.closest('.form-checkbox-ctn');

				if (tCheck.hasClass('required')) {
					if (!tCheck.is(':checked')) {
						tCtn.addClass('error');
						
						if (tCtn.attr('name') !== 'terms') {
							checkOk = false;
						}
					} else {
						tCtn.removeClass('error');
					}

					if (tCheck.attr('name') === 'terms' && tCtn.hasClass('error')) {
						termsOk = false;
					}

					if (tCtn.hasClass('error')) {
						termsOk = false;
					}
				} else {
					var lengthMinOneChecked = ctn.find('[name=' + this.name + '].min-one-checked:checked').length;
					if (lengthMinOneChecked === 0) {
						checkOk = false;
						tCtn.addClass('error');
					} else {
						tCtn.removeClass('error');
					}
				}
			});

			if (password.length !== 0 && passwordConfirm.length !== 0 && (password.val() !== passwordConfirm.val() || password.val().length === 0)) {
				if (password.val().length === 0) {
					password.removeClass('success').addClass('error');
					passwordOk = false;
				} else {
					password.addClass('success').removeClass('error');
					passwordOk = true;
				}

				if (password.val() !== passwordConfirm.val() || passwordConfirm.val().length === 0) {
					passwordConfirm.removeClass('success').addClass('error');
					passwordOk = false;
				} else {
					passwordConfirm.removeClass('error');
					passwordOk = true;

					if (password.val().length !== 0) {
						passwordConfirm.addClass('success');
					}
				}
			}

			if (email.length !== 0 && emailConfirm.length !== 0 && (email.val() !== emailConfirm.val() || email.val().length === 0)) {
				if (email.val().length === 0) {
					email.removeClass('success').addClass('error');
					emailOk = false;
				} else {
					email.addClass('success').removeClass('error');
					emailOk = true;
				}
                
				if (email.val() !== emailConfirm.val() || (email.val().length === 0)) {
					emailConfirm.removeClass('success').addClass('error');
					emailOk = false;
				} else {
					emailConfirm.removeClass('error');
					emailOk = true;

					if (email.val().length !== 0) {
						emailConfirm.addClass('success');
					}
				}
			}
            
			ctn.addClass('is-checked');

			if (!termsOk) {
				fieldsErrorTerms.slideDown(300);
			} else {
				fieldsErrorTerms.slideUp(300);
			}
			
			if (!checkOk) {
				fieldsErrorCheckbox.slideDown(300);
			} else {
				fieldsErrorCheckbox.slideUp(300);
			}
			
			if (!containsOk) {
				fieldsErrorContains.slideDown(300);
			} else {
				fieldsErrorContains.slideUp(300);
			}

			if (password.length !== 0 && passwordConfirm.length !== 0) {
				if (password.length !== 0 && passwordOk) {
					ctn.addClass('has-password');
					password.add(passwordConfirm).removeClass('error');
					fieldsErrorPassword.slideUp(300);
				} else {
					ctn.removeClass('has-password');
					password.add(passwordConfirm).addClass('error');
					fieldsErrorPassword.slideDown(300);
				}
			}

			if (email.length !== 0 && emailConfirm.length !== 0) {
				if (email.length !== 0 && emailOk) {
					ctn.addClass('has-email');
					email.add(emailConfirm).removeClass('error');
					fieldsErrorEmail.slideUp(300);
				} else {
					ctn.removeClass('has-email');
					email.add(emailConfirm).addClass('error');
					fieldsErrorEmail.slideDown(300);
				}
			}
            
			if (!isOk) {
				fieldsErrorMessage.slideDown(300);
			} else {
				fieldsErrorMessage.slideUp(300);
			}

			if (!isOk || !passwordOk || !termsOk || !checkOk || !emailOk || !containsOk) {
				btn.addClass('disabled');
				ctn.addClass('has-error');

				if (!passwordOk && password.hasClass('required')) {
					ctn.addClass('error-password');
				} else {
					ctn.removeClass('error-password');
				}
				return false;
			} else {
				btn.removeClass('disabled');
				ctn.removeClass('has-error').removeClass('error-password');

				fieldsErrorTerms.slideUp(300);
				return true;
			}
		});
	};
    
    var submitValidateForm = function(e) {
        e.preventDefault();
        
        validateForm(this);
        
        if (!$(this).hasClass('has-error')) this.submit();
    };
    
    var ajaxSubmit = function(e) {
        e.preventDefault();
        
        var $btn = $(this);
        var $form = $btn.closest('form');
        validateForm($form[0]);
        
        if (!$form.hasClass('has-error') && !$btn.hasClass('disabled')) {
            $btn.addClass('disabled');
            $.post({
                url: $form.attr('action'),
                data: $form.serialize() + '&ajax=true',
                cache: false,
                success: function(resp) {
                    $btn.removeClass('disabled');
                    $form.slideUp(400).next('.ajax-submit-success').fadeIn(400);
                    $form[0].reset();
                }
            });
        }
    };
    
    var showAjaxSubmitForm = function(e) {
        var $popup = $(this).parents('.popup');
        setTimeout(function() {
            $popup.find('.ajax-form').show();
            $popup.find('.ajax-submit-success').hide();
        }, 300);
    };
    
    var checkFieldValue = function(elt) {
        var val = elt.val();
		if (val && val.trim() !== '') {
			elt.addClass('has-value');
		} else {
			elt.removeClass('has-value');
		}
    };

	var validateField = function (elt) {
		var tag = elt[0].tagName;
		var type = elt.attr('type');
		var val = elt.val() || "";
		var attrClass = elt.attr('data-validator-apply-class-on');
		var classTarget = attrClass !== undefined ? elt.closest(attrClass) : elt;
		//Choises for validate are : "email", "url", "tel" or "default". By default, an input type email takes the email validation,
		//the input type tel takes the tel validation and if the validate value is "default", then it do a normal check if the input has char
		var validate = elt.attr('data-validate');
		var reEmail = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
		var reUrl = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+(:[0-9]+)?|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/;
		var reTel = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;
		var emailValid = true;
		var whiteSpaceValid = true;
		var urlValid = true;
		var telValid = true;
		var inputValid = true;

        checkFieldValue(elt);
        
        if (tag === 'TEXTAREA' && (!elt.hasClass('mceNoEditor') || elt.hasClass('mce-enabled'))) {
            try {
                val = window.tinymce.get(elt[0].id ? elt[0].id : elt[0].name).getContent();
            } catch (err) {
                console.error(err);
            }
        }

		if(!val.replace(/\s/g, '').length) {
			whiteSpaceValid = false;
		}

		if (tag === 'INPUT' && (type === 'email' && elt.hasClass('required') || validate === 'email') && validate !== 'default') {
			emailValid = reEmail.test(val);
		} else if (tag === 'INPUT' && validate === 'url' && validate !== 'default') {
			urlValid = reUrl.test(val);
		} else if (tag === 'INPUT' && (type === 'tel' || validate === 'tel') && validate !== 'default') {
			telValid = reTel.test(val);
		} else if (elt.hasClass('form-input-upload-input')) {
			if (classTarget.hasClass('required') && elt.val() !== '') {
				classTarget.removeClass('error').addClass('success');
			} else {
				classTarget.addClass('error').removeClass('success');
			}
		} else {
			if (classTarget.hasClass('required') && $.trim(val).length === 0) {
				classTarget.removeClass('success').addClass('error');
                inputValid = false;
			} else if (!classTarget.hasClass('required') && val.length === 0) {
				classTarget.removeClass('success').removeClass('error');
			}
		}

		if (emailValid && urlValid && telValid && inputValid && whiteSpaceValid) {
			classTarget.removeClass('error').addClass('success');
		} else if (val.length === 0 && !classTarget.hasClass('required')) {
			classTarget.removeClass('error').removeClass('success');
		} else {
			classTarget.addClass('error').removeClass('success');
		}
	};

	var formItemsBlur = function (t) {
		var elt = t.target === undefined ? t : $(this);
		var ctn = elt.closest('.form-input');
		var form = ctn.closest('.js-form');

		validateField(elt);

		if (form.hasClass('is-checked')) {
			validateForm(form);
		}
	};

	var formCheckChange = function () {
		var t = $(this);
		var ctn = t.closest('.form-checkbox-ctn');
		var form = ctn.closest('.js-form');
		
		if (form.hasClass('is-checked')) {
			validateForm(form);
			
			if (t.is(':checked')) {
				ctn.removeClass('error');
			}
		}
	};

	var checkLabelClick = function () {
		var t = $(this);
		var ctn = t.closest('.register-checkbox');

		if (ctn.hasClass('is-checked')) {
			ctn.removeClass('is-checked');
		} else {
			ctn.addClass('is-checked');
		}
	};

	var toggleCheckbox = function () {
		var t = $(this);
		var ctn = t.closest('.form-input-checkbox');
		var input = $('.form-input-checkbox-input', t);

		if (ctn.hasClass('checked')) {
			ctn.removeClass('checked');
			input.removeAttr('checked');
		} else {
			ctn.addClass('checked');
			input.attr('checked', 'checked');
		}
	};


	var fileInputChange = function () {
		var t = $(this);
		var label = t.closest('.form-input-upload-input-label');
		var labelDefault = label.attr('data-default-value');
		var labelValue = $('.form-input-upload-input-label-value:not(.btn)', label);
		var ctn = t.closest(t.attr('data-validator-apply-class-on'));
		var form = ctn.closest('.js-form');

		if (t.val() !== '') {
			ctn.removeClass('error').addClass('success');
			labelValue.html(t.val().split('\\')[t.val().split('\\').length - 1]);

		} else {
			ctn.addClass('error').removeClass('success');
			labelValue.html(labelDefault);
		}

		if (form.hasClass('is-checked')) {
			validateForm(form);
		}
	};

	var formSwitchClick =function (){
		var t = $(this);
		var elem = $(t).find('.checkbox');

		t.find('.form-checkbox-slider').toggleClass('active');
		if (elem.prop( "checked" )){
			elem.removeAttr( "checked" );
		}else{
			elem.attr( "checked", "checked" );
		}
	};
	
	var updateStateSelect = function () {
		var t = $(this);
		var val = t.val().toLowerCase();
		var form = t.closest('form');
		var statesCtn = $('.select-state-ctn', form);
		$('.form-select-ctn, .form-select-ctn .form-select', statesCtn).removeClass('selected');
		
		if (['ca', 'can', 'canada'].indexOf(val) > -1) {
            $('.form-select-ctn.us .form-select', statesCtn).removeAttr('name');
            $('.form-select-ctn.canada, .form-select-ctn.canada .form-select', statesCtn).addClass('selected');
            $('.form-select-ctn.canada .form-select', statesCtn).attr('name', 'province');
            $('.form-select-ctn.australia .form-select', statesCtn).removeAttr('name');
            $('.form-select-ctn.other .form-select', statesCtn).removeAttr('name');
        } else if (['us', 'usa', 'united-states'].indexOf(val) > -1) {
            $('.form-select-ctn.us, .form-select-ctn.us .form-select', statesCtn).addClass('selected');
            $('.form-select-ctn.us .form-select', statesCtn).attr('name', 'province');
            $('.form-select-ctn.canada .form-select', statesCtn).removeAttr('name');
            $('.form-select-ctn.australia .form-select', statesCtn).removeAttr('name');
            $('.form-select-ctn.other .form-select', statesCtn).removeAttr('name');
        } else if (['au', 'aus', 'australia'].indexOf(val) > -1) {
            $('.form-select-ctn.us .form-select', statesCtn).removeAttr('name');
            $('.form-select-ctn.canada .form-select', statesCtn).removeAttr('name');
            $('.form-select-ctn.australia, .form-select-ctn.australia .form-select', statesCtn).addClass('selected');
            $('.form-select-ctn.australia .form-select', statesCtn).attr('name', 'province');
            $('.form-select-ctn.other .form-select', statesCtn).removeAttr('name');
        } else {
            $('.form-select-ctn.us .form-select', statesCtn).removeAttr('name');
            $('.form-select-ctn.canada .form-select', statesCtn).removeAttr('name');
            $('.form-select-ctn.australia .form-select', statesCtn).removeAttr('name');
            $('.form-select-ctn.other, .form-select-ctn.other .form-select', statesCtn).addClass('selected');
            $('.form-select-ctn.other .form-select', statesCtn).attr('name', 'province');
		}
	};
    
    var setFieldsWithValues = function() {
        items = $('.form-input:not([type=file])');
        items.each(function() {
            checkFieldValue($(this));
        });
    };

	var splitDate = function(t) {
		var date = t.val().split('/');
		var ctn = t.closest('.input-ctn');

		ctn.find('.day').val(date[0]);
		ctn.find('.month').val(date[1] - 1);
		ctn.find('.year').val(date[2]);
	};
    
    var collectCheckboxValues = function(e) {
        var $ctn = $(e.delegateTarget || this).closest('.checkbox-value-collector');
        var $inp = $ctn.find('input[name="' + this.name.replace('Split', '') + '"]');
        var sep = $ctn.attr("data-separator") || " | ";
        var arr = [];
        
        $ctn.find('.form-check-input').each(function() {
            if (this.checked) arr.push(this.value);
        });
        
        $inp.val(arr.join(sep));
        if ($inp.hasClass('save-data')) {
            $inp.trigger('change');
        }
    };
    
    var submitAfterFileSelect = function(e) {
        var it = e.currentTarget || this;
        if (it.files[0]) {
            $('.popup-outer[data-id="newsletter_import_list_wait"]').addClass('open');
            it.form.submit();
        }
    };
    
    var transferElementDataToForm = function(e) {
        if (e) e.preventDefault();
        
        var $it = $(this || e.currentTarget),
            form = document.getElementById($it.attr("data-form")),
            inputs = form.elements,
            data = $it.closest(".element-data-item").data(),
            name;
        
        if ($it.attr("data-hide-elements")) {
            $($it.attr("data-hide-elements"), form).hide();
        }
        if ($it.attr("data-show-elements")) {
            $($it.attr("data-show-elements"), form).show();
        }
    
        $.each(inputs, function(i, el) {
            if (!el.hasAttribute("ignore")) {
                name = el.name.toLowerCase();
                if (el.type === "checkbox" || el.type === "radio") {
                    el.checked = data.hasOwnProperty(name) && data[name].toString() === el.value;
                } else {
                    el.value = data.hasOwnProperty(name) ? data[name] : "";
                }
            }
        });
        
        $(form).slideDown(400);
        scrollToElement(null, 'html, body', form, $(".site-header").height());
    };

	var init = function (page) {
		// currPage = $(page);
		body = $('body');
		items = $('.form-input:not([type=file])');

		checkLabel = $('.register-checkbox-label', currPage);
		checkboxItems = $('.form-input-checkbox', currPage);
		checkboxItemsInner = $('.form-input-checkbox-inner', checkboxItems);
		file = $('.form-input-upload', currPage);
		fileInput = $('.form-input-upload-input', file);
		formSwitch = $('.form-switch', currPage);
		formCheck = $('.form-check-input', currPage);
		selectCountry = $('.select-country-input');
		daysCell = $('.days-cell');

		checkLabel.click(checkLabelClick);
		checkboxItemsInner.click(toggleCheckbox);
		fileInput.change(fileInputChange);
		formSwitch.click(formSwitchClick);
		formCheck.change(formCheckChange);
		selectCountry.change(updateStateSelect);

		items.each(function () {
			var t = $(this);
			if (!t.hasClass('no-blur')) {
				t.blur(formItemsBlur);
			}
		});
        
        $('.form-validate').on('submit', submitValidateForm);
        $('.ajax-submit').on('click', ajaxSubmit);
        $('.ajax-submit-success').parents('.popup').find('.close-popup-btn').on('click', showAjaxSubmitForm);
        
        $('.checkbox-value-collector').on('change', '.form-check-input', collectCheckboxValues);
        
        $('.input-file-import').on('change', submitAfterFileSelect);
        
        setInterval(setFieldsWithValues, 800);
        
        $(".edit-element").on("click", transferElementDataToForm);
        
	};

	Fw.component.export('form', {
		init,
		validateForm,
		validateField,
        transferElementDataToForm
	});
	
	$(window).ready(init);

})(jQuery);

